import { Box, Button, Paper, styledComponent } from '@hermes/web-components'

export const ModalTitleContainer = styledComponent(Box)(({ theme }) => ({
  padding: '16px 54px',
  position: 'relative',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '.MuiTypography-root': {
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600
  }
}))

export const ModalBackButton = styledComponent(Button)({
  position: 'absolute',
  left: '16px',
  top: '18px'
})

export const ModalCloseButton = styledComponent(Button)({
  position: 'absolute',
  right: '16px',
  top: '18px'
})

export const ModalContainer = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  padding: '9px',
  [theme.breakpoints.down('xs')]: {
    alignItems: 'end'
  }
}))

export const ModalContent = styledComponent(Paper)({
  borderRadius: '10px',
  boxShadow: '0 20px 60px -2px rgb(27 33 58 / 40%)',
  width: '666px',
  height: 'auto',
  display: 'grid',
  overflow: 'hidden'
})

export const DoubleButtons = styledComponent(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  '.MuiButtonBase-root': {
    width: '50%',
    '&.Mui-disabled': {
      color: `${theme.palette.neutral[400]} !important`
    },
    '&:first-of-type': {
      borderRight: `1px solid ${theme.palette.divider}`,
      color: theme.palette.text.secondary
    },
    '&:last-child': {
      color: theme.palette.primary.main
    }
  }
}))
